import axios from 'axios';

const BASE = '/api';

const api = axios.create({
  baseURL: BASE,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

// Public routes where a 401 is EXPECTED (not logged in yet) — never force-redirect from these
const PUBLIC_PATHS = ['/', '/forgot-password', '/change-password'];

api.interceptors.response.use(
  res => res,
  err => {
    const status = err.response?.status;
    const onPublicPath = PUBLIC_PATHS.some(p => window.location.pathname.startsWith(p));

    // Only force a hard redirect on 401 if we're on a PROTECTED page and not already navigating.
    // This prevents the reload loop that happens when /login itself checks auth status (me.php)
    // and gets a 401 back — that 401 is normal and must NOT trigger a redirect.
    if (status === 401 && !onPublicPath) {
      window.location.href = '/';
    }

    return Promise.reject(err);
  }
);

export default api;
